import { memo } from 'react'

const Logo = () => <img src="../../../../assets/images/Logo_check_assistance_Appbar.svg" alt=""/>

export default memo(Logo);